/* eslint-disable no-case-declarations */
import {
  addItem,
  deleteChildren,
  updateItem,
} from '../../components/Tree/utils/manipulator';
import { uniqueId, uniqueJId } from '../../helpers/unique-id';

export const JOURNEY_MAX_LEVEL = 5;

const findLoactionByLegid = (id, legs) => {
  let indexPicked = null;
  let found = false;

  const legIndex = legs.findIndex((a) => a.id === id);

  if (legIndex >= 0) {
    indexPicked = legIndex;
    found = true;
  }

  return {
    legIndex: indexPicked,
    found,
  };
};

function findTargetLeg(id, value, legs = []) {
  if (value === 'STOP') {
    return undefined;
  }

  if (value === 'new-leg') {
    return legs.find((item) => item.id === id);
  }

  if (value === 'root') {
    return legs.find((item) => item.id === id);
  }

  return legs.find((item) => item.id === value);
}

export const updateConfigLegJourneySelectUpdateData = (state, action) => {
  let data = state.data && state.data.data ? state.data.data : {};

  const { found, legIndex } = findLoactionByLegid(
    action.id,
    data.configurations.legs
  );

  if (found) {
    let journeyTree = data.configurations.legs[legIndex]?.journeyTree || [];

    const details = action.details;

    let isTarget = true;
    let isStoploss = true;

    const targetLeg = findTargetLeg(
      action.id,
      details.value,
      data.configurations.legs
    );

    if (targetLeg) {
      isTarget = targetLeg?.target?.value ? true : false;
      isStoploss = targetLeg?.stoploss?.value ? true : false;
    }

    const dataToUpdate = {};

    const newJId = `${uniqueJId()}`;

    dataToUpdate.value = 'STOP';

    switch (details.value) {
      case 'STOP':
        dataToUpdate.value = 'STOP';

        journeyTree = deleteChildren(journeyTree, details.id, '_id');
        break;
      case 'new-leg':
        const newJLegId = `${uniqueId()}`;

        dataToUpdate.value = newJLegId;

        // new leg
        const copiedLeg = Object.assign({}, data.configurations.legs[legIndex]);

        const {
          // eslint-disable-next-line no-unused-vars
          journeyTree: _journeyTree,
          // eslint-disable-next-line no-unused-vars
          isJourney: _isJourney,
          // eslint-disable-next-line no-unused-vars
          mp: _mp,
          // eslint-disable-next-line no-unused-vars
          orb: _orb,
          id: copiedLegId,
          ...copiedLegRestProps
        } = copiedLeg;

        const newCopiedLeg = {
          ...copiedLegRestProps,
          parentId: copiedLegId,
          id: newJLegId,
        };

        data.configurations.legs = [...data.configurations.legs, newCopiedLeg];

        journeyTree = deleteChildren(journeyTree, details.id, '_id');

        break;
      case 'root':
        dataToUpdate.value = 'root';

        journeyTree = deleteChildren(journeyTree, details.id, '_id');

        break;
      default:
        dataToUpdate.value = details.value;

        journeyTree = deleteChildren(journeyTree, details.id, '_id');
        break;
    }

    if (details.value !== 'STOP') {
      const levelRaw = details.level || 0;
      const level = levelRaw + 1;

      const target = journeyTree.find((item) => item._id === details.id);

      const isNewLegItemHasChildren = target?.children?.length ? true : false;

      if (level <= JOURNEY_MAX_LEVEL && !isNewLegItemHasChildren) {
        if (isTarget) {
          journeyTree = addItem(
            journeyTree,
            details.id,
            {
              type: 'target',
              value: 'STOP',
              jId: newJId,
            },
            '_id'
          );
        }

        if (isStoploss) {
          journeyTree = addItem(
            journeyTree,
            details.id,
            {
              type: 'stoploss',
              value: 'STOP',
              jId: newJId,
            },
            '_id'
          );
        }
      }
    }

    data.configurations.legs[legIndex].journeyTree = updateItem(
      journeyTree,
      details.id,
      dataToUpdate,
      '_id'
    );

    data.configurations.legs[legIndex].updatedAtJourney = Date.now();
  }

  return {
    data: {
      ...state.data,
      data: data,
    },
  };
};
